import { countRecentMCs, getRecentMCs, resetCountRecentMCs } from 'Redux/modules/patient/actions';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

const useMcHistory = () => {
  const dispatch = useDispatch();
  const { status, mc, countMc } = useSelector(state => state.patients, shallowEqual);

  const countingMc = status.countMc === 0;
  const loadingMc = status.mc === 0;

  const getCountHistoryMc = useCallback(
    async (patientId, clinicId, consultServiceId) => {
      return dispatch(countRecentMCs(patientId, clinicId, consultServiceId));
    },
    [dispatch],
  );

  const getHistoryMc = useCallback(
    async (patientId, params) => {
      return dispatch(getRecentMCs(patientId, params));
    },
    [dispatch],
  );

  const reset = useCallback(() => {
    return dispatch(resetCountRecentMCs());
  }, [dispatch]);

  return {
    mc,
    countMc,
    countingMc,
    loadingMc,
    getCountHistoryMc,
    getHistoryMc,
    resetCountRecentMCs: reset,
  };
};

export default useMcHistory;
